//modality types
export const modalityTypes = Object.freeze({
  IndividualTherapy: 262,
  GroupTherapy: 263,
});
